import { observer } from 'mobx-react';
import times from 'lodash/times';

import '@components/mixins/commonStyles.scss';
import style from './TeethSelectMenu.module.scss';

import { MultiSelect, OptionType, Select } from '@components/Select';
import { Button } from '@components/Button';
import { TeethSelectMenuDataTest } from '@components/Blocks/RenderedService/TeethSelectMenu/data-test';
import { teethOptions } from '@components/Blocks/RenderedService/RenderedServiceEditForm/selectOptions';
import { useTeethSelect } from '@components/Blocks/RenderedService/TeethSelectMenu/hooks/useTeethSelect';
import { translate } from '@chaika/i18n/helper';
import { assertIsDefined } from '@utils/assertIsDefined';

interface Props {
    serviceId: string;
    count: number;
    onCreate(options: OptionType[]): Promise<void>;
    onCreateMulti?(options: OptionType[][]): Promise<void>;
}

export const TeethSelectMenu = observer(
    ({ count, onCreate, serviceId, onCreateMulti }: Props): React.ReactElement<any> => {
        const { options, multiOptions, onMultiSelect, onSelect, isDentalMulti, isCreateButtonDisabled, onCreateClick } =
            useTeethSelect({ count, onCreate, serviceId, onCreateMulti });

        return (
            <div className={style.root}>
                <div className={'font_h2'}>{translate('selectingTeeth')}</div>
                {times(count, it => String(it + 1)).map(key => {
                    return (
                        <>
                            {isDentalMulti ? (
                                <MultiSelect
                                    key={key}
                                    title={`${translate('toothForService')} ${key}`}
                                    name={key}
                                    dataTest={TeethSelectMenuDataTest.Select}
                                    options={teethOptions}
                                    selectedValues={multiOptions.get(key)?.map(it => {
                                        assertIsDefined(it.value, 'Selected tooth option value is a tooth number');
                                        return it.value.toString();
                                    })}
                                    onChange={onMultiSelect}
                                />
                            ) : (
                                <Select
                                    key={key}
                                    dataTest={TeethSelectMenuDataTest.Select}
                                    title={`${translate('toothForService')} ${key}`}
                                    name={key}
                                    options={teethOptions}
                                    selectedValue={options.get(key)?.value}
                                    onChange={onSelect}
                                />
                            )}
                        </>
                    );
                })}
                <div>
                    <Button
                        dataTest={TeethSelectMenuDataTest.SaveButton}
                        disabled={isCreateButtonDisabled}
                        label={translate('create')}
                        onClick={onCreateClick}
                    />
                </div>
            </div>
        );
    },
);
